"use strict";
/* globals module */
/**
 * @module notificationsSubscriptionsUsersRoute
 * @description Baasic Notifications Subscriptions Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var _1 = require("./");
var NotificationsSubscriptionsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsUsersRoute, _super);
    function NotificationsSubscriptionsUsersRoute(appOptions, notificationsSubscriptionsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsSubscriptionsUsersBatchRoute = notificationsSubscriptionsUsersBatchRoute;
        _this.createRoute = 'notifications/subscriptions/user';
        _this.findRoute = 'notifications/subscriptions/user/{?searchQuery,userIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/user/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/user/{id}';
        _this.updateRoute = 'notifications/subscriptions/user/{id}';
        return _this;
    }
    NotificationsSubscriptionsUsersRoute.prototype.batch = function () {
        return this.notificationsSubscriptionsUsersBatchRoute;
    };
    /**
     * Parses create user subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersRoute.create();
     */
    NotificationsSubscriptionsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find user subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscriptions subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example notificationsSubscriptionsUsersRoute.find({ searchQuery: '<search-phrase>', channels: '<channel-name>,<channel-name>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsUsersRoute.get({ id: '<subscription-id>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.delete(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.update(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchRoute !== "undefined" && _1.NotificationsSubscriptionsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsSubscriptionsUsersRoute);
    return NotificationsSubscriptionsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsUsersRoute = NotificationsSubscriptionsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
